import React from 'react';
import { ListGroup, Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useGetComponentsQuery } from '../../redux/services/tanProfilesApi';
import { getComponentsBySlug, addComponent, removeComponent, getSessionOptions } from '../../redux/slice/tanProfileSlice';
import liftImg from "../../assets/images/wellfit/WF_Solution_Logos-01.png"
import hydrateImg from "../../assets/images/wellfit/WF_Solution_Logos-02.png"
import balanceImg from "../../assets/images/wellfit/WF_Solution_Logos-03.png"
import "./popoverSelector.css"
const PopoverSelector = ({ itemtype, amount }) => {
    const dispatch = useDispatch();
    const componentData = useSelector((state) => getComponentsBySlug(state, itemtype)) || [];
    const profileData = useSelector((state) => state?.tanProfile?.selectedProfile?.session_component) || [];
    const sessionOptions = useSelector(getSessionOptions);
    const style = itemtype === "wellfit" ? "wellfit" : "tan"
    // const style = "tan"/
    // console.log(style)
    useGetComponentsQuery({}, { skip: componentData.length > 0 });

    const maxSelection = amount;
    const selected = profileData
        .map(entry => componentData.find(item => item.id === entry.component_value_id))
        .filter(Boolean);

    const allowDuplicates = (itemtype === 'bronzers' || itemtype === 'scents') && amount > 1;

    const getSelectionCount = (item) => selected.filter(sel => sel.id === item.id).length;

    const isSelected = (item) => getSelectionCount(item) > 0;

    const handleToggleItem = (item) => {
        const count = getSelectionCount(item);
        if (allowDuplicates) {
            if (count >= 2) {
                dispatch(removeComponent(item));
                dispatch(removeComponent(item));
            } else if (count === 1 && selected.length < maxSelection) {
                dispatch(addComponent(item));
            } else if (count === 1) {
                dispatch(removeComponent(item));
            } else if (count === 0 && selected.length < maxSelection) {
                dispatch(addComponent(item));
            }
        } else {
            if (count > 0) {
                dispatch(removeComponent(item));
            } else if (selected.length < maxSelection) {
                dispatch(addComponent(item));
            }
        }
    };
    const imageData = {
        403875: {
            img: liftImg
        },
        403874: {
            img: hydrateImg
        },
        403876: {
            img: balanceImg
        },
    }

    const buildItem = (item) => {
        const count = getSelectionCount(item);
        let itemColor = item.color ? item.color : "var(--button-pink)"
        if(itemtype === "scents"){ //overide requested by marketing.
            itemColor = "var(--button-pink)"
        }
        if (imageData[item.sku]) {
            return <div
                key={item.id}
                className={`popover-image-item rectangle-style-${style} ${isSelected(item) ? 'selected' : 'unselected'}`}
                onClick={() => handleToggleItem(item)}
                style={{borderColor: itemColor}}
            >
                {count >= 2 && <span key="x2" className="x2-badge">x2</span>}
                <img src={imageData[item.sku].img}></img>
                <div className='popover-image-text'>
                    {item.description}
                </div>
            </div>
        } else {
            return <div
                key={item.id}
                className={`popover-item d-flex align-items-center ${isSelected(item) ? 'selected' : 'unselected'}`}
                onClick={() => handleToggleItem(item)}
            >
                {count >= 2 && <span key="x2" className="x2-badge">x2</span>}
                <div className={"popover-circle " + ""} style={{ backgroundColor: itemColor }}>
                    {item.value.toUpperCase()}
                </div>
                <div className={`popover-rectangle rectangle-style-${style} ${isSelected(item) ? 'selected' : 'unselected'}`}
                style={{}}>
                    {item.description}
                </div>
            </div>
        }
    }
    return (
        <div className='popover-selector-scroll'>
            {componentData.map(buildItem)}
        </div>
    );
};

export default PopoverSelector;
